import { createAction, createReducer } from "@reduxjs/toolkit";

import {
  OfferSliceState,
  OfferStateEntry,
  OfferSyncPayload,
} from "./offer-types";

export const initialState: OfferSliceState = {
  lastKnownOfferStates: {},
  hasOfferStatusChange: false,
};

export const syncOfferData = createAction<OfferSyncPayload>(
  "offer/syncOfferData",
);
export const syncOfferDataSilent = createAction<OfferSyncPayload>(
  "offer/syncOfferDataSilent",
);
export const acknowledgeAllOfferState = createAction("offer/acknowledgeAll");

function buildOfferStates(
  offers: OfferSyncPayload["offers"],
): Record<string, OfferStateEntry> {
  const states: Record<string, OfferStateEntry> = {};
  for (const offer of offers) {
    if ("id" in offer) {
      // Family
      states[offer.opportunitySuggestionId] = {
        userId: offer.offeredByUserId,
        offerState:
          "family" +
          "__" +
          offer.offerState +
          "__" +
          offer.caregiverPrice +
          "__" +
          offer.caseSalary +
          "__" +
          offer.familyPrice +
          "__" +
          offer.opportunitySuggestionState,
      };
    } else {
      // Caregiver
      states[offer.opportunitySuggestionId] = {
        userId: offer.offeredByUserId,
        offerState:
          "caregiver" + "__" + offer.offerStatus + "__" + offer.caseSalary,
      };
    }
  }
  return states;
}

export const offerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(syncOfferData, (state, action) => {
      const { offers, userId: currentUserId } = action.payload;
      const offerStates = buildOfferStates(offers);

      // Detect offer status changes (including new offers)
      // Skip change detection on first sync (no previous data)
      const hasPreviousData =
        Object.keys(state.lastKnownOfferStates).length > 0;
      if (hasPreviousData) {
        for (const [id, { userId, offerState: newState }] of Object.entries(
          offerStates,
        )) {
          const previousState = state.lastKnownOfferStates[id]?.offerState;
          if (
            userId !== currentUserId &&
            (!previousState || previousState !== newState)
          ) {
            state.hasOfferStatusChange = true;
            break;
          }
        }
      }
      state.lastKnownOfferStates = offerStates;
    })
    .addCase(syncOfferDataSilent, (state, action) => {
      const { offers } = action.payload;
      state.lastKnownOfferStates = buildOfferStates(offers);
    })
    .addCase(acknowledgeAllOfferState, (state) => {
      state.hasOfferStatusChange = false;
    });
});
